import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import EventDetails from './pages/EventDetails';
import Checkout from './pages/Checkout';
import CustomerLookup from './pages/CustomerLookup';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="nav-logo">
              Events Ticketing System
            </Link>
            <ul className="nav-menu">
              <li className="nav-item">
                <Link to="/" className="nav-link">Dashboard</Link>
              </li>
              <li className="nav-item">
                <Link to="/customer-lookup" className="nav-link">Customer Lookup</Link>
              </li>
            </ul>
          </div>
        </nav>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/event/:id" element={<EventDetails />} />
            <Route path="/checkout/:token" element={<Checkout />} />
            <Route path="/customer-lookup" element={<CustomerLookup />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;